module.exports = __webpack_public_path__ + "static/media/img41.beba2b8a.jpg";